import { ComponentSelector, ComponentInjector } from '@atypon/ui-utils';
import CoreQuickSearch, { QuickSearchClassList, QuickSearchElements, QuickSearchSelectors, QuickSearchTexts, QuickSearchElm } from 'ui-core/widgets/quick-search/js/quick-search';

class ClassList extends QuickSearchClassList {
}

class Selectors extends QuickSearchSelectors {
    journalSearchHideAutocompleteWrapper = '.journal-search__wrapper';
}

class Elements extends QuickSearchElements {
    citationSubmit: HTMLElement;
}

interface QuickSearch {
    get elements(): Elements;
    get classList(): ClassList;
    get selectors(): Selectors;
}

@ComponentInjector(Selectors, Elements, ClassList, QuickSearchTexts)
class QuickSearch extends CoreQuickSearch {

    protected resultListConfig(quickSearchElm: QuickSearchElm) {
        return { ...super.resultListConfig(quickSearchElm), position: 'afterbegin' };
    }
}


export default QuickSearch;

export {
    Elements as ClassicQuickSearchElements,
    Selectors as ClassicQuickSearchSelectors,
    ClassList as ClassicQuickSearchClassList,
}